import { render } from "./new-supplier.vue?vue&type=template&id=10d2adba"
import script from "./new-supplier.vue?vue&type=script&lang=js"
export * from "./new-supplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__